<script lang="ts">
  import { browser } from "$app/environment";
  import { page } from "$app/stores";
  import { how_far_to_scroll_in_gallery, header_menu_height } from "$lib/data";
  import { get_pattern } from "$lib/utilities";

  let thing: HTMLElement;
  let y: number;

  export let round_top: boolean = false;

  //Returns true if it is a DOM element
  const is_element = (o: any) =>
    typeof HTMLElement === "object"
      ? o instanceof HTMLElement //DOM2
      : o &&
        typeof o === "object" &&
        o !== null &&
        o.nodeType === 1 &&
        typeof o.nodeName === "string";

  // for gallery pagination
  $: if (is_element(thing) && browser && $$slots.map && browser) {
    $how_far_to_scroll_in_gallery =
      thing.getBoundingClientRect().bottom + y - $header_menu_height;
  }
</script>

<svelte:window bind:scrollY={y} />
<div class="mainStuff">
  <div>
    {#if $$slots.map}
      <div class="map_holder" bind:this={thing}>
        <slot name="map">Map</slot>
      </div>
    {/if}

    {#if $$slots.title}
      <header style:background-image={get_pattern()}>
        <slot name="title">Member Extras</slot>
      </header>
    {/if}

    {#if !$page.url.pathname.includes("/gallery")}
      <div
        class="content"
        class:nopadding={!$$slots.title}
        class:gallery={!$$slots.title && $$slots.map}
        class:round_top
      >
        <slot name="content" />
      </div>
    {/if}
  </div>
  {#if $$slots.below_content}
    <div
      class="below_content"
      class:nopadding={$page.url.pathname.includes("/gallery")}
    >
      <slot name="below_content" />
    </div>
  {/if}
</div>

<style>
  .mainStuff {
    position: relative;
    z-index: 2;
    width: calc(73% - 2rem);
  }
  .mainStuff .map_holder {
    position: relative;
    z-index: 2;
    background-color: #75cff0;
    border-radius: 2rem 2rem 0 0;
    overflow: hidden;
  }
  @media (max-width: 450px) {
    .mainStuff .map_holder {
      border-radius: 0;
    }
  }
  @media (max-width: 450px) {
    .mainStuff {
      border-radius: 0;
    }
  }
  .mainStuff header {
    padding: 2rem 2rem 1.5rem 2rem;
    border-bottom: 1px solid var(--dots);
    border-radius: 2rem 2rem 0 0;
    background-color: white;
    overflow: hidden;
    color: transparent;
    font-family: "Open Sans", sans-serif;
    font-weight: bold;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: var(--title);
    text-shadow: 1.5px 1.5px var(--primary);
    font-size: 2rem;
  }
  @media (max-width: 450px) {
    .mainStuff header {
      border-radius: 0;
    }
  }
  .mainStuff .content {
    border-radius: 0 0 2rem 2rem;
    box-shadow: var(--shadow);
    background: white;
    padding: 3rem;
  }
  .mainStuff .content.round_top {
    border-radius: 2rem;
  }
  .mainStuff .content.nopadding {
    padding: 0;
  }
  .mainStuff .content.gallery {
    padding: 3rem;
  }
  @media (max-width: 450px) {
    .mainStuff .content {
      border-radius: 0;
    }
  }
  .mainStuff .below_content {
    padding-top: 2rem;
  }
  .mainStuff .below_content.nopadding {
    padding: 0;
  }
  @media (max-width: 1024px) {
    .mainStuff .below_content {
      padding-top: 2rem;
    }
  }
  @media (max-width: 800px) {
    .mainStuff .below_content {
      padding-top: 1rem;
    }
  }

  @media (max-width: 1024px) {
    .mainStuff {
      width: 100%;
      margin-top: 3rem;
    }
  }
  @media (max-width: 1023px) {
    .mainStuff {
      margin-top: 5rem;
    }
  }
  @media (max-width: 768px) {
    .mainStuff {
      border-radius: 0;
      margin-top: 5rem;
    }
    .mainStuff .below_content {
      background: var(--background);
    }
    .mainStuff header {
      text-align: center;
      border-top: 1px dashed var(--comment_accent);
    }
    .mainStuff .content {
      padding: 1rem;
    }
    .mainStuff .content.gallery {
      padding: 1rem;
    }
  }
</style>
